module.exports = __webpack_public_path__ + "static/media/l_biodina.470375c8.png";